export const GEAR_TEXT_STYLE = {
  default: {
    size: 24,
    fontFamily: 'Brown',
    fontWeight: 700
  },
  medium: { size: 28 },
  'large+extraLarge': { size: 32 }
};

export const TEXT_TRACK_TEXT_FEEDBACK_STYLE = {
  default: {
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    fontFamily: 'Brown',
    fontWeight: 700
  },
  medium: {
    fontSize: '24px'
  },
  'large+extraLarge': {
    fontSize: '32px'
  }
};

export const ICON_SUB_TITLE_SIZE = {
  extraSmall: { size: 16 },
  default: { size: 24 }
};

export const TEXT_TRACK_TEXT_FEEDBACK_WRAPPER_STYLE = {
  display: 'flex',
  gap: '4px',
  alignItems: 'flex-start',
  flexDirection: 'column',
  padding: '16px 8px',
  backgroundColor: 'rgba(40, 40, 40, 0.9)',
  width: 'max-content'
};
